import type { OcrProcessResult } from "@/lib/api";

const HERO_OCR_KEY = "jdca:hero-ocr:v1";
const HERO_SESSION_KEY = "jdca:acquisition-session:v1";

export const getAcquisitionSessionId = (): string => {
  try {
    const existing = sessionStorage.getItem(HERO_SESSION_KEY);
    if (existing) return existing;
    const created = typeof crypto !== "undefined" && "randomUUID" in crypto
      ? crypto.randomUUID()
      : `acq-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem(HERO_SESSION_KEY, created);
    return created;
  } catch {
    return `acq-${Date.now()}`;
  }
};

export const persistHeroOcr = (result: OcrProcessResult): void => {
  try {
    sessionStorage.setItem(HERO_OCR_KEY, JSON.stringify(result));
  } catch {
    // The in-memory transition still works when storage is unavailable.
  }
};

export const readHeroOcr = (): OcrProcessResult | null => {
  try {
    const raw = sessionStorage.getItem(HERO_OCR_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as OcrProcessResult;
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
};

export const clearHeroOcr = (): void => {
  try { sessionStorage.removeItem(HERO_OCR_KEY); } catch { /* ignore */ }
};
